import {
  fetchingUserData,
  fetchingOrders,
  fetchingNotes,
  fetchingSms,
  fetchingMessages,
  fetchingTransactions,
  addNote,
  deleteNote,
} from './actions';
export const initialState = {
  fetchingUserData,
  fetchingOrders,
  fetchingNotes,
  fetchingSms,
  fetchingMessages,
  fetchingTransactions,
  addNote,
  deleteNote,
  driver: null,
  notes: null,
  orders: null,
  allSms: null,
  messages: null,
  transactions: null,
};

export const reducer = (state, action) => {
  const { type, payload } = action;
  switch (type) {
    case 'LOAD':
      return {
        ...state,
        [payload.name]: payload.value,
      };
    case 'NOTES':
      return { ...state, notes: payload };
    case 'CHANGE_DRIVER_INFO':
      return {
        ...state,
        driver: {
          ...state.driver,
          [payload.name]: payload.value,
        },
      };
    case 'CHANGE_FLEET_PLATE':
      return {
        ...state,
        driver: {
          ...state.driver,
          numberPlate: {
            ...state.driver.numberPlate,
            [payload.name]: payload.value,
          },
        },
      };
    default:
      return state;
  }
};
